import {
  Handle,
  Position,
} from 'reactflow';
import 'reactflow/dist/style.css';

// Custom node component for model blocks
export const ModelBlockNode = ({ data }: { data: any }) => {  const isStartEnd = data.node_type === 'start' || data.node_type === 'end';
  const isDataDriven = data.model?.category === 'MLP';
  const isMechanistic = data.model?.category && ['algebraic', 'ODE', 'PDE', 'DAE'].includes(data.model.category);

  // Get the number of actual connections (edges) for this node
  const inputCount = data.inputEdgeCount || 0;
  const outputCount = data.outputEdgeCount || 0;
  // Handle click on mechanistic models
  const handleNodeClick = () => {
    console.log('[ModelBlockNode] Click detected on node:', data.name);
    console.log('[ModelBlockNode] Is mechanistic:', isMechanistic);
    console.log('[ModelBlockNode] Model data:', data.model);
    console.log('[ModelBlockNode] Has onModelClick:', !!data.onModelClick);
    
    if (isMechanistic && data.model && data.onModelClick) {
      console.log('[ModelBlockNode] Calling onModelClick with:', { name: data.name, model: data.model });
      data.onModelClick(data.name, data.model);
    }
  };

  // Determine node styling based on type
  const getNodeStyle = () => {
    if (isStartEnd) {
      return {
        background: '#f3f4f6',
        border: '2px solid #9ca3af',
        borderRadius: '50%',
        padding: '12px',
        minWidth: '80px',
        minHeight: '80px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
    } else if (isDataDriven) {
      return {
        background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
        border: '2px solid #1d4ed8',
        borderRadius: '12px',
        padding: '16px',
        color: 'white',
        minWidth: '160px',
        boxShadow: '0 4px 8px rgba(59, 130, 246, 0.3)'
      };
    } else if (isMechanistic) {
      return {
        background: 'linear-gradient(135deg, #10b981, #047857)',
        border: '2px solid #047857',
        borderRadius: '8px',
        padding: '16px',
        color: 'white',
        minWidth: '160px',
        boxShadow: '0 4px 8px rgba(16, 185, 129, 0.3)'
      };
    } else {
      return {
        background: '#f8fafc',
        border: '2px solid #64748b',
        borderRadius: '8px',
        padding: '16px',
        minWidth: '160px'
      };
    }
  };  return (
    <div 
      style={{
        ...getNodeStyle(),
        cursor: isMechanistic ? 'pointer' : 'default'
      }}
      onClick={handleNodeClick}
    >{/* Input handles - rendered based on actual incoming edges */}
      {!isStartEnd && Array.from({ length: inputCount }, (_, index) => (
        <Handle
          key={`input-${index}`}
          type="target"
          position={Position.Left}
          id={`input-${index}`}
          style={{
            top: `${((index + 1) * 100) / (inputCount + 1)}%`,
            background: '#374151',
            border: '2px solid white',
            width: '12px',
            height: '12px'
          }}
        />
      ))}
      
      {/* Output handles - rendered based on actual outgoing edges */}
      {!isStartEnd && Array.from({ length: outputCount }, (_, index) => (
        <Handle
          key={`output-${index}`}
          type="source"
          position={Position.Right}
          id={`output-${index}`}
          style={{
            top: `${((index + 1) * 100) / (outputCount + 1)}%`,
            background: '#374151',
            border: '2px solid white',
            width: '12px',
            height: '12px'
          }}
        />
      ))}

      {/* Start/End nodes have single handles */}
      {data.node_type === 'start' && (
        <Handle
          type="source"
          position={Position.Right}
          style={{
            background: '#374151',
            border: '2px solid white',
            width: '12px',
            height: '12px'
          }}
        />
      )}
      
      {data.node_type === 'end' && (
        <Handle
          type="target"
          position={Position.Left}
          style={{
            background: '#374151',
            border: '2px solid white',
            width: '12px',
            height: '12px'
          }}
        />
      )}

      <div className="text-center">
        <div style={{ fontWeight: 'bold', fontSize: '12px', marginBottom: '4px' }}>
          {data.name}
        </div>
        {data.model?.category && (
          <div style={{ fontSize: '10px', opacity: 0.9 }}>
            {data.model.category}
          </div>
        )}
      </div>
    </div>
  );
};